module.exports = __webpack_public_path__ + "media/images/default/shared/header/nav-cover3-81d7e449703d9605ab3abc9f8ed93e03.jpg";